var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('AppHeader',{attrs:{"user":_vm.$store.state.user},on:{"mobileMenuToggle":function($event){_vm.showMobileMenu = !_vm.showMobileMenu}}}),_c('b-container',{staticClass:"app-body",attrs:{"fluid":"","tag":"main"}},[_c('RouterView',{staticClass:"layout-full__content"})],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }